import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { motion } from "framer-motion";
import { FaBed, FaUserFriends, FaWifi, FaTv, FaSnowflake, FaUtensils, FaBath, Fa } from 'react-icons/fa';
import { MdBalcony, MdLandscape } from 'react-icons/md'; // alternatif balkon
import { Navigate, useNavigate } from 'react-router-dom';

const HomePage = () => {
    const navigate = useNavigate();

    const [date, setDate] = useState(() => {
        const today = new Date();
        return today.toISOString().split('T')[0]; // "YYYY-MM-DD"
    });
    
    const [pageIndex, setPageIndex] = useState(0);
    const [pageSize, setPageSize] = useState(10);

    const [data, setData] = useState([]);
    const [isNextPage, setIsNextPage] = useState(true);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_ROOMS = "api/staynest/mobile/Rooms";

    // Fetch data from the API
    const fetchData = async (URL, config) => {
        try {
            const response = await axios.get(URL, config);
            return response.data; // Return only the data from the response
        } catch (err) {
            setError("Failed to fetch data. Please try again later.");
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(`${BASE_URL}${PATH_ROOMS}`, {
            params: {
                offset: pageIndex,
                limit: pageSize
            }
        }).then((data) => {
            setData(data.data);
        });
    }, []);

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div className="p-6 space-y-16 bg-gradient-to-b from-indigo-50 to-white min-h-screen">
            <header className="text-center py-10">
                <h1 className="text-4xl font-bold text-indigo-700 mb-4">Welcome to StayNest</h1>
                <span>
                  <i className="text-lg font-bold text-gray-600">Stay cozy.</i>
                  <b className="text-lg text-indigo-700"> StayNest.</b>
                </span>
            </header>
            {/* <h1 className="text-3xl font-bold mb-6 text-center">Hotel Room Catalog</h1> */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {data.map((room) => (
                    <motion.div
                        key={room.room_id}
                        whileHover={{ scale: 1.03 }}
                        className="cursor-pointer"
                        onTap={() => {
                            navigate(`/activity-staynest/room/detail/${room.room_id}/${date}`);
                        }}
                    >
                        <div className="rounded-2xl shadow-lg overflow-hidden bg-white">
                            <img
                                src={`${BASE_URL}/upload/staynest/${room._photo}`}
                                alt={room.name}
                                className="w-full h-48 object-cover"
                            />
                            <div className="p-4">
                                <h2 className="text-xl font-semibold mb-2 text-gray-800">{room.room_name}</h2>
                                <ul className="text-sm text-gray-700 space-y-1 mb-2">
                                    <li><strong>Property Type:</strong> {room.property_type}</li>
                                    <li><strong>Room Type:</strong> {room.room_type}</li>
                                    <li><strong>Bed Type:</strong> {room.bed_type}</li>
                                    <li><strong>Capacity:</strong> {room.capacity} person(s)</li>
                                </ul>
                                <div className="flex flex-wrap items-center gap-2 text-sm text-gray-600 mb-2">
                                    {room._facilites.includes('Sarapan') && (
                                        <div className="flex items-center gap-1">
                                            <FaUtensils /> Sarapan
                                        </div>
                                    )}
                                    {room._facilites.includes('Kamar Mandi Dalam') && (
                                        <div className="flex items-center gap-1">
                                            <FaBath /> Kamar Mandi Dalam
                                        </div>
                                    )}
                                    {room._facilites.includes('AC') && (
                                        <div className="flex items-center gap-1">
                                            <FaSnowflake /> AC
                                        </div>
                                    )}
                                    {room._facilites.includes('Wi-Fi') && (
                                        <div className="flex items-center gap-1">
                                            <FaWifi /> Wi-Fi
                                        </div>
                                    )}
                                    {room._facilites.includes('TV') && (
                                        <div className="flex items-center gap-1">
                                            <FaTv /> TV
                                        </div>
                                    )}
                                    {room._facilites.includes('Balkon') && (
                                        <div className="flex items-center gap-1">
                                            <MdBalcony />
                                            Balkon
                                        </div>
                                    )}
                                </div>
                                <div className="text-lg font-bold text-indigo-600">
                                    Rp {Number(room._current_price).toLocaleString('id-ID')}/malam
                                </div>
                            </div>
                        </div>
                    </motion.div>
                ))}
            </div>
        </div>

    );
}

export default HomePage;